<template>
    <CCard style="height: 100%; overflow-y: auto">
        <CCardHeader>
            <CIcon :src="Logo" />
            <p class="title mb-0 d-inline-block ml-2">
                SpendMD News
            </p></CCardHeader
        >
        <CCardBody>
            <CCard v-for="news in spendmdNews" :key="news.id" class="news-card">
                <CCardBody style="cursor: pointer">
                    <CRow>
                        <CCol sm="10">
                            <p class="news mb-0">{{ news.news }}</p>
                        </CCol>
                        <CCol sm="2">
                            <i class="fas fa-chevron-right float-right"></i>
                        </CCol>
                    </CRow>

                    <p class="news-type mb-0 d-inline">{{ news.type }}</p>
                    <p class="news-type mb-0 d-inline float-right">
                        {{ news.date }}
                    </p>
                </CCardBody>
            </CCard>
        </CCardBody>
    </CCard>
</template>

<script>
import Logo from "../../../containers/sidebar-icons/Parent Names.svg";

export default {
    data() {
        return {
            Logo,
            spendmdNews: [],
        };
    },
    beforeMount() {
        this.spendmdNews = [
            {
                type: "QFS News",
                news: "Lorem Ipsum is simply dummy text of the printing",
                date: "08 Aug",
                id: 1,
            },
            {
                type: "QFS News",
                news: "Lorem Ipsum is simply dummy text of the printing",
                date: "08 Aug",
                id: 2,
            },
            {
                type: "QFS News",
                news: "Lorem Ipsum is simply dummy text of the printing",
                date: "08 Aug",
                id: 3,
            },
            {
                type: "QFS News",
                news: "Lorem Ipsum is simply dummy text of the printing",
                date: "08 Aug",
                id: 4,
            },
            {
                type: "QFS News",
                news: "Lorem Ipsum is simply dummy text of the printing",
                date: "08 Aug",
                id: 5,
            },
        ];
    },
};
</script>

<style scoped>
.news {
    color: #1f2621 !important;
    text-align: left;
    font: normal normal 700 14px/24px Lato;
    letter-spacing: 0px;
    color: #1f2621;
    opacity: 1;
}
.news-type {
    color: #9ca8a9;
    text-align: left;
    font: normal normal normal 10px/24px Lato;
    letter-spacing: 0px;
    color: #9ca8a9;
    opacity: 1;
}
.card {
    border: 1px solid var(--stroke);
    box-shadow: 0px 5px 10px #00000008;
    border: 1px solid #e0e4e4;
    border-radius: 7px;
    opacity: 1;
}
.news-card:hover {
    transform: scale(1, 1.1);
    transition: transform 0.2s;
}
.title {
    text-align: left;
    font: normal normal normal 16px/24px Lato;
    letter-spacing: 0px;
    color: #1f2621;
    opacity: 1;
}
</style>